// extracted by mini-css-extract-plugin
export default {"root":"wxASYv5GBAbyQILr12YP","contentWrapper":"rShiosxbTWxa1pLTFlLt"};